import { MONOCHROME_SOCIAL_ICONS, OFFICIAL_SOCIAL_ICONS, type SocialIconKey } from './social-icons-data'

let idCounter = 0

/**
 * Gradient and clip path ids must be unique in a web page: the first definition wins, even when it is hidden
 */
function withUniqueIds(svgContent: string): string {
  if (!svgContent.includes(' id="')) {
    return svgContent
  }
  idCounter += 1
  const suffix = `-${idCounter}`
  return svgContent.replace(/ id="([^"]+)"/g, ` id="$1${suffix}"`).replace(/url\(#([^)]+)\)/g, `url(#$1${suffix})`)
}

/**
 * Builds the svg markup of a social icon: the official logo, or its single color glyph when a monochrome color is given
 */
export function getSocialIconXml(key: SocialIconKey, size: number, monochromeColor?: string): string {
  const icon = monochromeColor === undefined ? OFFICIAL_SOCIAL_ICONS[key] : MONOCHROME_SOCIAL_ICONS[key]
  const fill = monochromeColor ?? icon.fill
  const attributes = [
    `width="${size}"`,
    `height="${size}"`,
    `viewBox="${icon.viewBox ?? '0 0 24 24'}"`,
    fill !== undefined ? `fill="${fill}"` : '',
    icon.preserveAspectRatio !== undefined ? `preserveAspectRatio="${icon.preserveAspectRatio}"` : '',
  ]
  return `<svg xmlns="http://www.w3.org/2000/svg" ${attributes.filter(Boolean).join(' ')}>${withUniqueIds(icon.svgContent)}</svg>`
}
